import MasterCrudPage from '../../components/MasterCrudPage';

export default function Races() {
  return (
    <MasterCrudPage
      config={{ title: 'Race', apiBase: '/payroll/masters/races', listKey: 'races', entityKey: 'race', fields: [], bare: true }}
    />
  );
}
